import { render, staticRenderFns } from "./related_merge_requests.vue?vue&type=template&id=a6c3e530&"
import script from "./related_merge_requests.vue?vue&type=script&lang=js&"
export * from "./related_merge_requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports